import type { ProjectActionReadinessEvent } from "@afar-research/contracts";

export function projectActionReadinessToast(event: ProjectActionReadinessEvent) {
  return event.type === "repaired"
    ? {
        type: "success" as const,
        title: "AFAR Project repaired automatically",
        description: event.message,
      }
    : {
        type: "error" as const,
        title: "AFAR Project action blocked",
        description: `${event.finding.message} ${event.finding.recovery}`,
      };
}
